<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <div class="search-list">
          <div class="search-top">
            <div class="title">搜索列表</div>
            <div class="btn" @click="toSearch(null)">+ 创建高级搜索</div>
          </div>
          <el-table
            :data="searchList"
            class="order-table table no-border-table"
            height="600"
            ref="orderTable"
            :header-cell-style="{
              border: '1px solid #E8E8E8',
              color: '#333',
              background: '#f6f6f6',
              height: '44px',
            }"
            :row-style="{
              height: '44px',
            }"
          >
            <el-table-column
              prop="created"
              align="center"
              label="创建时间"
              width="150"
            ></el-table-column>
            <el-table-column
              prop="title"
              align="center"
              label="标题"
            ></el-table-column>
            <el-table-column label="操作" align="center" width="130">
              <div
                slot-scope="scope"
                style="display: flex;justify-content: center;"
              >
                <div>
                  <button
                    size="mini"
                    class="table-btn"
                    style="color: #5283FF;cursor: pointer;margin: 0 5px;"
                    @click="getPortraitSearchResult(scope.row)"
                  >
                    查看
                  </button>
                </div>
                <div>
                  <button
                    size="mini"
                    class="table-btn"
                    style="color: #5283FF;cursor: pointer;margin: 0 5px;"
                    @click="toSearch(scope.row.id, scope.row)"
                  >
                    编辑
                  </button>
                </div>
                <div>
                  <button
                    size="mini"
                    class="table-btn"
                    style="color: #5283FF;cursor: pointer;margin: 0 5px;"
                    @click="deletePortraitSearch(scope.row.id)"
                  >
                    删除
                  </button>
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div class="result-box">
          <!-- <div class="search-content">
            <div class="title">
              高级搜索标题：XXXXXXXXXX
            </div>
            <div class="search-data-list">
              <div class="search-item">
                <div class="label">角色：</div>
                角色类型1
              </div>
              <div class="search-item">
                <div class="label">角色：</div>
                角色类型1
              </div>
              <div class="search-item">
                <div class="label">角色：</div>
                角色类型1
              </div>
            </div>
          </div> -->
          <!-- <div class="result-num">
            查询到<span>32</span>个用户符合条件
          </div> -->
          <div class="result-list">
            <div v-if="!resultList.length" style="width:100%;text-align: center;">
              暂无数据
            </div>
            <div v-else class="result-total">
              查询到<span>{{ resultList.length }}</span>个用户符合条件
            </div>
            <div
              class="result-item"
              v-for="(item, index) in resultList"
              :key="index"
            >
              <div class="user-top">
                <img :src="item.avatar" alt="" class="avatar" />
                <div class="info">
                  <div class="name">{{ item.nickname }}</div>
                  <div class="role">
                    <div>{{ item.familyRole }}</div>
                    <div>ID:{{ item.uid }}</div>
                  </div>
                </div>
              </div>
              <div class="user-bottom" v-if="false">
                <div class="info-item">
                  <div class="label">角色：</div>
                  角色类型1
                  <div class="line"></div>
                </div>
                <div class="info-item">
                  <div class="label">宝宝性别：</div>
                  角色类型1
                  <div class="line"></div>
                </div>
                <div class="info-item">
                  <div class="label">出生日期：</div>
                  角色类型1
                  <div class="line"></div>
                </div>
                <div class="info-item">
                  <div class="label">喂养方式：</div>
                  角色类型1
                  <div class="line"></div>
                </div>
                <div class="info-item">
                  <div class="label">喂养方式：</div>
                  角色类型1
                  <div class="line"></div>
                </div>
                <div class="info-item">
                  <div class="label">角色：</div>
                  角色类型1
                  <div class="line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      loading: 0, // 加载中
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      title: {
        // 页面标题
        firstTitile: '用户管理',
        secondTitle: '用户画像数据'
      },
      searchList: [],
      resultList: []
    };
  },
  mounted() {
    // 获取列表
    this.getPortraitSearchList();
  },
  computed: {},
  methods: {
    // 获取轮播列表
    getPortraitSearchList() {
      this.loading++;
      this.httpGet(this.$root.getPortraitSearchList, {}).then(
        (res) => {
          this.loading--;
          this.searchList = res.list;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getPortraitSearchResult(row){
      this.loading++;
      this.httpPost(this.$root.getPortraitSearchResult, {
        id: row.id,
        title: row.title,
        relation: row.relation,
        ...JSON.parse(row.searchAttrs)
      }).then(
        (res) => {
          this.loading--;
          this.resultList = res.user;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    toUserDetail(uid){
      this.$router.push({
        name: 'userDetail',
        query: {
          uid
        }
      });
    },
    deletePortraitSearch(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该搜索吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deletePortraitSearch, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPortraitSearchList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      }).catch(() => {
        // 点击取消或关闭的逻辑
      });
    },
    toSearch(id, row = {}){
      let query = {};
      if(id){
        query = {
          id,
        }
      }
      this.$router.push({
        name: 'portraitDataSearch',
        query
      });
    }
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;
  background: #F6F6F6;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    // padding: 0 20px 20px;
    background: #F6F6F6;


    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      // background: white;
      box-sizing: border-box;
      padding: 10px 12px;
      border-radius: 2px;
      overflow: hidden;
      flex-x(flex-start, flex-start);
      .search-list{
        width: 450px;
        height: 100%;
        background: #fff;
        padding: 0 20px;
        box-sizing: border-box;
        border-radius: 5px;
        margin-right: 8px;
        .search-top{
            height: 64px;
            flex-x();
            box-sizing: border-box;
            .title{
                word(16px, #333);
            }
            .btn{
                padding: 0 12px;
                height: 32px;
                border-radius: 5px;
                background: #5283FF;
                word(14px, #fff);
                flex-x(center, center);
                cursor: pointer;
            }
        }
      }
      .result-box{
        min-width: 600px;
        flex: 1;
        height: 100%;
        // background: #fff;
        border-radius: 5px;
        overflow: hidden;
        box-sizing: border-box;
        .search-content{
            background: #fff;
            flex-y(flex-start, flex-start);
            padding: 20px;
            box-sizing: border-box;
            .title{
                word(16px, #666);
            }
            .search-data-list{
                margin-top: 8px;
                flex-x(flex-start, flex-start);
                .search-item{
                    height: 32px;
                    flex-x(flex-start);
                    word(14px, #333);
                    padding-right: 20px;
                    box-sizing: border-box;
                    // border-right: 1px solid #C9C9C9;
                    .label{
                        word(14px, #999);
                    }
                }
            }
        }
        .result-num{
            height: 48px;
            padding-left: 24px;
            flex-x(flex-start);
            span{
                color: #618EFF;
                margin: 0 3px;
            }
        }
        .result-total{
          height: 40px;
          flex-x(flex-start);
          word(14px, #333);
          padding-left: 24px;
          flex-shrink: 0;
          span{
            color: #618EFF;
          }
        }
        .result-list{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            flex-y(flex-start, flex-start);
            box-sizing: border-box;
            flex-shrink: 0;
            .result-item{
                width: 100%;
                background: #fff;
                padding: 12px 20px;
                box-sizing: border-box;
                flex-y(flex-start, flex-start);
                flex-shrink: 0;
                .user-top{
                    flex-x(flex-start, flex-start);
                    .avatar{
                        width: 44px;
                        height: 44px;
                        // background: red;
                        border-radius: 22px;
                        margin-right: 10px;
                    }
                    .info{
                        flex-y(center, flex-start);
                        .name{
                            word(16px, #333);
                        }
                        .role{
                            flex-x(flex-start, flex-start);
                            margin-top: 8px;
                            div{
                                padding: 0 8px;
                                height: 18px;
                                border-radius: 2px;
                                background: #E3EBFF;
                                word(10px, #4873E0);
                                flex-x(center);
                                margin-right: 12px;
                            }
                        }
                    }
                }
                .user-bottom{
                    flex-x(flex-start);
                    flex-wrap: wrap;
                    margin-top: 12px;
                    .info-item{
                        height: 32px;
                        flex-x(flex-start);
                        word(14px, #333);
                        .label{
                            word(14px, #666);
                        }
                        .line{
                            height: 8px;
                            width: 0;
                            border-right: 1px solid #C9C9C9;
                            margin-left: 20px;
                            margin-right: 20px;
                        }
                        &:nth-last-of-type(1){
                            .line{
                                display: none;
                            }
                        }
                    }
                }
            }
        }
      }
    }
  }
  .form {
    margin-top: 30px;
    margin-bottom: 30px;
    padding-left: 40px;
  }
}
</style>
